import React, { useEffect, useState } from 'react';
import { useNavigation } from '../../context/NavigationContext';
import { BringzzPageContainer, BringzzIcon, BringzzText, BringzzQrCode, BringzzButton } from "@bringzz/components";
import useRequest from 'hooks/useRequest';
import { useOrder } from 'context/OrderContext';
import { useSocket } from 'context/SocketClusterContext';
import usePageState from 'hooks/usePageState';
import { useParams } from 'react-router-dom';
import { USER_ROLES } from 'utils/constants';
import useUser from 'hooks/useUser';

const QR_CODE_TYPES = {
    CUSTOMER_PICKUP_IDENTIFY: 'customer/pickup/identify',
    SHOPPER_PICKUP_IDENTIFY: 'shopper/pickup/identify',
    PHARMACY_PICKUP_IDENTIFY: 'pharmacy/pickup/identify',
    CUSTOMER_COLLECT_IDENTIFY: 'customer/collect/identify',
    PHARMACY_PRESCRIPTION_VALIDATE: 'pharmacy/prescription/validate',
}

const QR_CODE_TITLES = {
    [QR_CODE_TYPES.PHARMACY_PRESCRIPTION_VALIDATE]: "Rezept QR Code",
}

const QR_CODE_INSTRUCTIONS = {
    [QR_CODE_TYPES.PHARMACY_PRESCRIPTION_VALIDATE]: "Scan the QR-Code with your pharmacy system to validate the prescription.",
    [QR_CODE_TYPES.CUSTOMER_COLLECT_IDENTIFY]: "Show the QR-Code to verify that you belong to the order.",
}

const QrCodePage = () => {
    const { backPress, navigate, state } = useNavigation();
    const { sendRequest } = useRequest()
    const { orderDetails, proceedToNextStep, refetchOrder } = useOrder()
    const { sendMessage, onRefetchData } = useSocket();
    const formData = usePageState();
    const [qrCode, setQrCode] = useState(null);
    const { getUser } = useUser();
    const user = getUser();
    const { role, type, mode } = useParams();
    const qrCodeType = role && type && mode ? QR_CODE_TYPES[`${role.toUpperCase()}_${type.toUpperCase()}_${mode.toUpperCase()}`] : null;

    useEffect(() => {
        if (formData?.value) {
            setQrCode(formData?.value);
        }
    }, [formData]);

    const returnQrCode = () => {
        if (user?.userRole == USER_ROLES.CONSUMER_ROLE) {
            return orderDetails.customerUUID;
        } else if (user?.userRole == USER_ROLES.SHOPPER_ROLE){
            return orderDetails.shopperUUID;
        } 
        return "12345678";
    }

    useEffect(() => {
        const cleanupRefetchData = onRefetchData((data) => {
            console.log({ data });
            if (data.notificationType.includes("ORDER_PROGRESS_")) {
                if (parseInt(data.notificationType.split("_")[2])) {
                    // proceedToNextStep();
                    console.log('======================================')
                    console.log(user?.userRole)
                    console.log(USER_ROLES.SHOPPER)
                    if (user?.userRole == USER_ROLES.SHOPPER_ROLE) {
                        navigate(`/matchmaking/shopper/${data.notificationType.split("_")[2]}`)
                    } else {
                        navigate(`/matchmaking/customer/${data.notificationType.split("_")[2]}`)
                    }
                } else {
                    console.error(`qrcode page: matchmaking/${data.notificationType.split("_")[2]} not integer`);
                }
            }
            return;
        });

        refetchOrder()

        return () => {
            if (cleanupRefetchData) {
                cleanupRefetchData();
            }
        };
    }, [onRefetchData])

    return (
        <BringzzPageContainer
            header={{
                right: <BringzzIcon
                    size="18"
                    icon="IconClose"
                    folder="LineIcons"
                    className="cursor-pointer"
                    onClick={backPress}
                />,
                title: <BringzzText tag='h2'>{QR_CODE_TITLES[qrCodeType]}</BringzzText>,
            }}
            footer={
                <div className="flex justify-center p-4 gap-4">
                    {qrCodeType == QR_CODE_TYPES.PHARMACY_PRESCRIPTION_VALIDATE && <div className="w-1/2">
                        <BringzzButton
                            size="lg"
                            className="bg-magic-lilac w-full flex justify-center text-midnight-blue"
                            onClick={() => navigate('/prescription/valid')}
                        >
                            {"Continue"}
                        </BringzzButton>
                    </div>}
                </div>
            }
            footerHover={true}>
            <div className='flex justify-center items-center w-full flex-col'>
                <BringzzText tag='h3' className={'font-normal p-12 text-center'}>{QR_CODE_INSTRUCTIONS[qrCodeType]}</BringzzText>
                <div className='mt-18'>
                    <BringzzQrCode value={returnQrCode() || "123456789"} />
                </div>
            </div>
        </BringzzPageContainer>

    )
}

export default QrCodePage;